//20260508追加
let cardButtonCartInFlag = false;

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.cartNotification.setActiveElement(document.activeElement);

      // fetch(`${routes.cart_url}`, { ...fetchConfig('javascript') })
      //   .then((response) => response.json())
      //   .then((parsedState) => {
      //     console.log(parsedState);
      //   })
      //   .catch((e) => {
      //     console.error(e);
      //   })

      let dataAddToCart = $('select[name="options[種類]"]').val()+$('input[name="planOption"]:checked').val();
      let dataInCart = $('#variantNameItemInCard').val()+$('#sellingPlanIDInCard').val();
      const submitButton = this.querySelector('[type="submit"]');
      
      if (submitButton.classList.contains('disable_by_subscription')) {
        alert('通常商品と定期購入商品を同時に注文することは出来ません。');
      } else if (submitButton.classList.contains('disable_by_subscription_periodic')
        && dataAddToCart != $('button[type="submit"][name="add"]').attr('data-productInCartData')
        && dataAddToCart != dataInCart) {
        alert('複数の定期購入商品を同時に注文することは出来ません。');
      } else if (submitButton.classList.contains('disabled_by_ship')) {
        alert('冷蔵便の商品と冷凍便の商品を同時に注文することは出来ません。');
      } else if (submitButton.classList.contains('disabled_by_special')) {
        alert('年末限定商品と他の商品を同時に注文することは出来ません。');
      } else if (submitButton.classList.contains('disabled_by_NotIncluded')) {
        alert('同梱不可商品と同梱包商品を同時に注文することは出来ません。');
      } else if (submitButton.classList.contains('disabled_by_NotIncluded-cartin')) {
        alert('既にカート内に同梱不可商品が入っています。');
      } else if (submitButton.closest('.product-card-buy-button') && submitButton.classList.contains('disable_by_subscription_periodic')) {
        //20260508アラートの条件を追加 定期商品カードで複数カートインしようとした時
        alert('複数の定期購入商品を同時に注文することは出来ません。');
      } else {
        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');
  
        const body = JSON.stringify({
          ...JSON.parse(serializeForm(this.form)),
          sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });
  
        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then((parsedState) => {
            this.cartNotification.renderContents(parsedState);
            if ($('#checkBySubscription').val() == 'true') {
              if (localStorage.getItem("productInCartData") !== null) {
                console.log(localStorage.getItem("productInCartData"));
              }
              let productInCartData = '';
              productInCartData = $('select[name="options[種類]"]').val()+$('input[name="planOption"]:checked').val();
              $('button[type="submit"][name="add"]').attr('data-productInCartData', productInCartData);
              $('button[type="submit"]').addClass("disable_by_subscription_periodic");
            }

            //20260508 購入ボタンに保存したカートアイテム数が0の時のみ発火
            const cartItemSize = Number(submitButton.getAttribute('data-cart-item-size'));
            if(!cardButtonCartInFlag && cartItemSize === 0){
              this.setButtonClass(submitButton);
            }

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
          });
      }
    }

    setButtonClass(btn) {
      //20260508 商品カードのカートインボタン カートインされた商品によってクラスを追加
      const cartItemTag = JSON.parse(btn.getAttribute('data-cart-in-tag'));//ボタンのデータ属性をjson化
      const cartButtons = document.querySelectorAll('button.product-form__submit');
      if(cartButtons.length === 0)return;
      cartButtons.forEach((button) => {
        const buttonCartTag =JSON.parse( button.getAttribute('data-cart-in-tag'));//ボタンのデータ属性をjson化

        if(btn === button){
          //同じ商品でも定期購入品は複数購入できない
          if(cartItemTag.subscription) {
            if (buttonCartTag.subscription) button.classList.add('disable_by_subscription_periodic');
          }else {
            return
          }
        }

        if(cartItemTag.subscription) {
          if (!buttonCartTag.subscription) button.classList.add('disable_by_subscription');
          else button.classList.add('disable_by_subscription_periodic');
        }else if (cartItemTag.special) {
          // カートに「特別商品」が含まれている場合
          if (!buttonCartTags.special) button.classList.add('disabled_by_special');
        }else {
          if (cartItemTag.fridge) {
            // カートに「冷蔵品」が含まれている場合
            if (buttonCartTag.subscription) button.classList.add('disable_by_subscription');
            else if (buttonCartTag.frozen) button.classList.add('disabled_by_ship');
            else if (buttonCartTag.special) button.classList.add('disabled_by_special');
          } else if (cartItemTag.frozen) {
            // カートに「冷凍品」が含まれている場合
            if (buttonCartTag.subscription) button.classList.add('disable_by_subscription');
            else if (buttonCartTag.fridge) button.classList.add('disabled_by_ship');
            else if (buttonCartTag.special) button.classList.add('disabled_by_special');
          }
        }
      })
      cardButtonCartInFlag = true;
    }
  });
}
